export const TenantsTable = {
  attributes: {
    sketchIngestion: "sketch-ingestion-value",
    eventIngestion: "event-ingestion-value"
  }
};
